import _classCallCheck from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import { Component } from "react";
var ForceRedirect = /*#__PURE__*/function (_Component) {
  _inherits(ForceRedirect, _Component);
  var _super = _createSuper(ForceRedirect);
  function ForceRedirect() {
    _classCallCheck(this, ForceRedirect);
    return _super.apply(this, arguments);
  }
  _createClass(ForceRedirect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        push = _this$props.push,
        to = _this$props.to;
      if (push) {
        window.location.assign(to);
      } else {
        window.location.replace(to);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return ForceRedirect;
}(Component);
export { ForceRedirect as default };